var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hashtag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.31494 10.1017H10.4449L10.6849 7.97168H8.55494L8.31494 10.1017Z",
    fill: "#2E4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6425 1.53809H6.3575C3.6275 1.53809 2 3.16559 2 5.89559V12.1731C2 14.9106 3.6275 16.5381 6.3575 16.5381H12.635C15.365 16.5381 16.9925 14.9106 16.9925 12.1806V5.89559C17 3.16559 15.3725 1.53809 12.6425 1.53809ZM14.615 7.97309H11.7875L11.5475 10.1106H14.075C14.375 10.1106 14.6225 10.3581 14.6225 10.6581C14.6225 10.9581 14.375 11.2056 14.075 11.2056H11.4275L11.12 13.9506C11.09 14.2281 10.85 14.4381 10.5725 14.4381C10.55 14.4381 10.535 14.4381 10.5125 14.4381C10.2125 14.4081 9.995 14.1306 10.025 13.8306L10.3175 11.2056H8.1875L7.88 13.9506C7.85 14.2281 7.61 14.4381 7.3325 14.4381C7.31 14.4381 7.295 14.4381 7.2725 14.4381C6.9725 14.4081 6.755 14.1306 6.785 13.8306L7.0775 11.2056H4.385C4.085 11.2056 3.8375 10.9581 3.8375 10.6581C3.8375 10.3581 4.085 10.1106 4.385 10.1106H7.2125L7.4525 7.97309H4.925C4.625 7.97309 4.3775 7.72559 4.3775 7.42559C4.3775 7.12559 4.625 6.87809 4.925 6.87809H7.5725L7.88 4.13309C7.91 3.83309 8.1875 3.61559 8.4875 3.64559C8.7875 3.67559 9.005 3.95309 8.975 4.25309L8.6825 6.87809H10.8125L11.12 4.13309C11.1575 3.83309 11.4275 3.61559 11.7275 3.64559C12.0275 3.67559 12.245 3.95309 12.215 4.25309L11.9225 6.87809H14.63C14.93 6.87809 15.1775 7.12559 15.1775 7.42559C15.1775 7.72559 14.915 7.97309 14.615 7.97309Z",
    fill: "#2E4347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.e3a2941eb2468d248525a17456228e39.svg";
export { ForwardRef as ReactComponent };